import { api } from "./apiClient";

export const analyticsAPI = {
  // Existing endpoint retained for current project analytics.
  getByProject: (projectId) => api.get(`/projects/${projectId}/analytics`),
  inspectorPerformance: (projectId, params = {}, signal) =>
    api.get(`/projects/${projectId}/analytics/inspector-performance`, { params, signal }),
  inspectorDetails: (projectId, params = {}, signal) =>
    api.get(`/projects/${projectId}/analytics/inspector-performance/inspections`, { params, signal }),
  globalPerformance: (params = {}, signal) =>
    api.get('/admin/analytics/performance', { params, signal }),
  globalEngagement: (params = {}, signal) =>
    api.get('/admin/analytics/engagement', { params, signal }),
  ingestEngagement: (events) =>
    api.post('/analytics/engagement/batch', { events }),
  createReport: (body) => api.post('/admin/analytics/reports', body, { timeout: 120000 }),
  reports: () => api.get('/admin/analytics/reports'),
  reportRecipients: () => api.get('/admin/analytics/report-recipients'),
  reportDownloadLink: (id) => api.get(`/admin/analytics/reports/${id}/download-link`),
  downloadReport: (id) => api.get(`/admin/analytics/reports/${id}/download`, {
    responseType: 'blob', timeout: 120000,
  }),
  sendReport: (id, recipients) =>
    api.post(`/admin/analytics/reports/${id}/send`, { recipients }),
};
